import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Card } from "@/pages/admin/panel/ui";

const CLASSES = [
  { key: "transactional", label: "Transactional", detail: "magic links, OTP codes, receipts, entitlement notices · smtp.postmarkapp.com · stream outbound · no unsubscribe" },
  { key: "broadcast", label: "Broadcast (drip / marketing)", detail: "drip and cross-sell sequences · smtp-broadcasts.postmarkapp.com · stream POSTMARK_BROADCAST_STREAM · unsubscribe link required, suppressions honoured" },
];

export function MailTestCard() {
  const [busy, setBusy] = useState("");
  const [last, setLast] = useState({});
  const send = async (key) => {
    setBusy(key);
    try {
      const { data } = await api.post(`/admin/mail/test/${key}`);
      setLast((l) => ({ ...l, [key]: data }));
      toast.success(`${key} test sent to ${data.to} — Postmark ID ${data.message_id} on stream "${data.stream}"`);
    } catch (e) {
      setLast((l) => ({ ...l, [key]: { error: errMsg(e) } }));
      toast.error(errMsg(e), { duration: 12000 });
    }
    setBusy("");
  };
  return (
    <Card icon={Mail} title="Postmark streams — send a test to yourself" testid="mail-test-card">
      <div className="space-y-2">
        {CLASSES.map((c) => {
          const r = last[c.key];
          return (
            <div key={c.key} data-testid={`mail-test-${c.key}`} className="flex flex-wrap items-center gap-3 border-b border-zinc-100 last:border-0 py-2">
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-zinc-800">{c.label}</p>
                <p className="text-xs text-zinc-500">{c.detail}</p>
                {r && !r.error && (
                  <p className="text-xs text-emerald-700 mt-1" data-testid={`mail-test-${c.key}-result`}>
                    Sent to {r.to} · Postmark ID <span className="font-mono">{r.message_id}</span> · stream <span className="font-mono">{r.stream}</span> · {r.host} · {r.mode}
                  </p>
                )}
                {r?.error && <p className="text-xs text-red-700 mt-1" data-testid={`mail-test-${c.key}-result`}>{r.error}</p>}
              </div>
              <button data-testid={`mail-test-${c.key}-btn`} disabled={busy === c.key} onClick={() => send(c.key)}
                      className="px-3 py-1.5 rounded-md bg-zinc-900 text-white text-xs font-semibold hover:bg-zinc-700 disabled:opacity-50">
                {busy === c.key ? "Sending…" : "Send test"}
              </button>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
